export const Trans_esp = {
	'projects': 'proyectos',
	'users': 'usuarios',
	'tools': 'herramientas',
	'there are no options to list': 'no hay opciones para listar',
	'select Option': 'escoger opción',
	'insert number': 'agregar número',
	'insert text': 'agregar texto',
	'all Rights Reserved': 'todos los derechos reservados',
	'create project': 'crear proyecto',
	'project title': 'título proyecto',
	'project status': 'estado proyecto',
	'project type': 'tipo proyecto',
	'episodes': 'episodios',
	'episode': 'episodio',
	'duration': 'duración',
	'genre': 'género',
	'production base country': 'país base producción',
	'production point person': 'punto contacto producción',
	'develop point person': 'punto contacto desarrollo',
	'short synopsis': 'sínopsis corta',
	'add more information': 'agregar más información',
	'create': 'crear',
	'cancel': 'cancelar',
	'canceled': 'cancelado',
	'projects pipeline': 'pipeline proyectos',
	'share': 'compartir',
	'filter': 'filtrar',
	'export': 'exportar',
	'search': 'buscar',
	'title': 'título',
	'status': 'estado',
	'type': 'tipo',
	'existing material': 'material existente',
	'pre production start': 'inicio pre producción',
	'pre-production start': 'inicio pre producción',
	'production end': 'fin producción',
	'episode 1': 'episodio 1',
	'50% completed': '50% completado',
	'budget': 'presupuesto',
	'budgets': 'presupuestos',
	'file': 'archivo',
	'chapter': 'libreto',
	'version:': 'versión',
	'potencial clients': 'clientes potenciales',
	'writer(s)': 'escritor(es)',
	'director(s)': 'director(es)',
	'writers': 'escritores',
	'directors': 'directores',
	'writer': 'escritor',
	'director': 'director',
	'client': 'cliente',
	'tentative cast': 'elenco tentativo',
	'talent': 'talento',
	'chapter_abbr': 'cAP',
	'scene_abbr': 'eSC',
	'minute_abbr': 'mIN',
	'location_studio_abbr': 'loc/est',
	'exterior_interior_abb': 'ext/int',
	'day_night_abb': 'día/noche',
	'projectd_minutes_abb': 'min proy',
	'login': 'inicio sesión',
	'continue': 'continuar',
	'your user is not created on Production logik, please contact': 'su usuario no ha sido creado en Production Logik, por favor contactar',
	'average_abbr': 'prom',
	'pending_abbr': 'pend',
	'search project': 'Buscar proyecto',
	'go back': 'regresar',
	'view': 'ver',
	'parameters': 'parámetros',
	'production plan': 'plan producción',
	'chapters': 'capítulos',
	'scenes': 'escenas',
	'characters': 'personajes',
	'locations': 'locaciones',
	'elements': 'elementos',
	'shooting schedule': 'planes diarios',
	'calendar': 'calendario',
	'minutes': 'minutos',
	'receive': 'recibir',
	'search chapters': 'buscar capítulos',
	'view scenes': 'ver escenas',
	'deliver chapter': 'entregar capítulos',
	'deliver': 'entregar',
	'add scene': 'agregar escena',
	'hide totals': 'ocultar totales',
	'on location': 'en locación',
	'on set': 'en set',
	'loc int day': 'loc int día',
	'loc int night': 'loc int noche',
	'loc ext day': 'loc ext día',
	'loc ext night': 'loc ext noche',
	'protections': 'protecciones',
	'proj min': 'min proy',
	'prod scenes': 'escenas prod',
	'prod prot': 'prot prod',
	'prod min': 'min prod',
	'cancel min': 'min cancel',
	'rep min': 'min rep',
	'shooting date': 'fecha grabación',
	'location': 'locación',
	'unit': 'unidad',
	'vehicles': 'vehículos',
	'other elements': 'otros elementos',
	'events': 'eventos',
	'description': 'descripción',
	'prod_minutes_abb': 'min prod',
	'projected_abb': 'proy',
	'produced_abb': 'prod',
	'produced_scenes_abbr': 'esc prod',
	'produced_protection_abbr': 'prot prod',
	'protections_abbr': 'prot',
	'locations_abbr': 'loc',
	'comments': 'comentarios',
	'receive date': 'fecha recibido',
	'drag and drop here or click to browse a file': 'arrastra o haz clic acá para agregar un archivo',
	'comment': 'comentario',
	'receive chapter': 'recibir capítulo',
	'scene type': 'tipo de scena',
	'chapter from': 'capítulo desde',
	'chapter to': 'capítulos hasta',
	'day history from': 'día de historia desde',
	'day history to': 'día de historia hasta',
	'units': 'unidades',
	'date from': 'fecha desde',
	'date to': 'fecha hasta',
	'location / studio': 'locación / estudio',
	'day / night': 'día / noche',
	'filter scenes': 'filtrar escenas',
	'only selected characters': 'solo personajes seleccionados',
	'at least one selected character': 'por lo menos uno de los personajes seleccionados',
	'element categories': 'categorías elementos',
	'protection types': 'tipos de protección',
	'only added scenes': 'solo hijuelas',
	'only establishing shoot': 'solo tomas de ubicación',
	'only flashback': 'solo flashbacks',
	'only manually produced': 'solo producidas manualmente',
	'scene number': 'número de escena',
	'day history': 'día de historia',
	'year': 'año',
	'page': 'página',
	'pages': 'páginas',
	'establishing shoot': 'toma de ubicación',
	'produced': 'producida',
	'click to add new character': 'clic para agregar nuevo personaje',
	'click to add new element': 'clic para agregar nuevo elemento',
	'click to add new event': 'clic para agregar nuevo evento',
	'click to add new comment': 'clic para agregar nuevo comentario',
	'character role': 'rol de personaje',
	'character': 'personaje',
	'category': 'categoría',
	'element': 'elemento',
	'event type': 'tipo evento',
	'quantity': 'cantidad',
	'view scene detail': 'ver detalle escena',
	'assign scene': 'asignar escena',
	'edit scene': 'editar escena',
	'duplicate scene': 'duplicar escena',
	'cancel scene': 'cancelar escena',
	'delete scene': 'eliminar escena',
	'this shooting schedule status is': 'este plan diario está en estado',
	'call': 'llamado',
	'shoot': 'grabando',
	'lunch': 'almuerzo/comida',
	'day': 'día',
	'shooting schedules': 'planes diarios',
	'advance call': 'llamada anticipada',
	'physical locations': 'locaciones físicas',
	'nearest hospital': 'hospital cercano',
	'monday': 'lunes',
	'tuesday': 'martes',
	'wednesday': 'miércoles',
	'thursday': 'jueves',
	'friday': 'viernes',
	'saturday': 'sábado',
	'sunday': 'domingo',
	'requirements': 'requerimientos',
	'log': 'bitácora',
	'rehearsal start': 'inicio ensayo',
	'rehearsal end': 'fin ensayo',
	'shooting start': 'inicio grabación',
	'shooting end': 'fin grabación',
	'character / talent': 'personaje / talento',
	'make up': 'maquillaje',
	'wardrobe': 'vestuario',
	'arrive': 'llegada',
	'notes': 'notas',
	'talent call': 'llamado talento',
	'no talent assigned': 'talento no asignado',
	'add': 'agregar',
	'save': 'guardar',
	'time': 'hora',
	'add advance call': 'agregar llamada anticipada',
	'add new location': 'agregar nueva locación',
	'add basecamp': 'agregar basecamp',
	'physical location': 'locación física',
	'add physical location': 'agregar locación física',
	'physical location percent': 'porcentaje locación física',
	'studio percent': 'porcentaje estudio',
	'weeks on location': 'semanas en locación',
	'weeks on studio': 'semanas en estudio',
	'location days': 'días locación',
	'average location days': 'promedio días locación',
	'studio days': 'días estudio',
	'average studio days': 'promedio días estudio',
	'maximum minutes to produce location': 'máximos minutos a producir locación',
	'maximum minutes to produce studio': 'máximos minutos a producir estudio',
	'reference minutes to produce daily location': 'referencia minutos a producir diario locación',
	'reference minutes to produce daily studio': 'referencia minutos a producir diario estudio',
	'average minutes to produce daily location': 'promedio de minutos a producir locación',
	'average minutes to produce daily studio': 'promedio de minutos a producir estudio',
	'scenes breakdown': 'escenas desglosadas',
	'maximum scenes location': 'maximas escenas locación',
	'maximum scenes studio': 'maximas escenas estudio',
	'hospital name': 'nombre hospital',
	'address': 'dirección',
	'city': 'ciudad',
	'country': 'país',
	'state': 'departamento',
	'add talent call': 'agregar llamado talento',
	'there are no extras assigned to this shooting schedule': 'no hay extras asignados a este plan diario',
	'extras type': 'tipo extra',
	'add extras call': 'agregar llamado extras',
	'extras call': 'llamado extras',
	'unit cost': 'costo unidad',
	'total cost': 'costo total',
	'services': 'servicios',
	'description / vendor': 'descripción / proveedor',
	'observations': 'observaciones',
	'vendor': 'proveedor',
	'contact person': 'persona contacto',
	'contact phone': 'teléfono contacto',
	'add service': 'agregar servicio',
	'no services created for this category': 'no hay servicios creados para esta categoría',
	'shooting logs': 'bítacora grabación',
	'scene': 'escena',
	'shooting times': 'horas de grabación',
	'add log': 'agregar bitácora',
	'no crew added for this deparment': 'no hay crew asignado para este departamento',
	'add crew call': 'agregar llamado crew',
	'edit crew call': 'editar llamado crew',
	'job': 'cargo',
	'department': 'departamento',
	'user': 'usuario',
	'add new user': 'agregar nuevo usuario',
	'given name': 'nombre',
	'surename': 'apellido',
	'add radio': 'agregar radio',
	'frecuency': 'frecuencia',
	'close': 'cerrar',
	'publish': 'publicar',
	'release': 'liberar',
	'release scene': 'liberar escena',
	'confirm': 'confirmar',
	'unrelease': 're asignar',
	'unproduce': 'desproducir',
	'unrelease scene': 're asignar escena',
	'unproduce scene': 'desproducir scena',
	'add image': 'agregar imagen',
	'link to scene': 'vincular a escena',
	'shooting time': 'hora grabación',
	'days': 'días',
	'crew call on set': 'crew en set',
	'ready to shoot': 'listo para grabar',
	'unit name': 'nombre unidad',
	'shootings': 'planes diarios',
	'weekly shooting reports': 'reporte grabación semanal',
	'view report': 'ver reporte',
	'continuity': 'continuidad',
	'set continuity': 'continuidad set',
	'view all': 'ver todos',
	'delete image': 'borrar imagen',
	'add continuity': 'agregar continuidad',
	'upload a maximum of': 'subir un máximo de',
	'images at a time': 'imagenes al tiempo',
	'choose files or drag them here': 'arrastrar o agregar imagen',
	'observation': 'observación',
	'insert': 'agregar',
	'there are no continuity images created': 'no hay imágenes de continuidad creadas',
	'order table': 'ordenar tabla',
	'modification': 'modificación',
	'there are no shooting schedule created': 'no hay planes diarios creados',
	'main cast': 'reparto principal',
	'daily cast': 'diarios',
	'date': 'fecha',
	'filter shooting schedule': 'filtrar planes',
	'add unit': 'Agregar unidad',
	'start date': 'fecha de inicio',
	'end date': 'fecha de fin',
	'view shooting schedule': 'ver plan diario',
	'no events added to this scene': 'no hay eventos agregados a esta escena',
	'no crew added for this department': 'no hay crew en este departamento',
	'in case of emergency contact': 'en caso de emergencia contactar',
	'general call': 'llamado general',
	'next shooting': 'siguiente llamado',
	'merge': 'unificar',
	'merge set': 'unificar sets',
	'location from': 'locación desde',
	'location to': 'lacación hacia',
	'set from': 'set desde',
	'set to': 'set hacia',
	'all scenes assigned to': 'todas las escenas asignadas a',
	'will be moved to': 'serán movidas a',
	'onces you reassign them, this cannot be roolback': 'una vez se reasignen no se puede revertir',
	'chapters reports': 'reportes capítulos',
	'report': 'reporte',
	'color box': 'caja de color',
	'copy data from scene': 'copiar desde escena',
	'system will copy characters and elements from scene selected': 'el sistema copiará los personajes y los elementos de la escena seleccionada',
	'edit': 'editar',
	'delete': 'eliminar',
	'scene status': 'estado escena',
	'proj minutes': 'minutos proy',
	'prod minutes': 'minutos prod',
	'non eff minutes': 'minutos no efec',
	'secondary cast': 'elenco secundario',
	'scene detail': 'detalle escena',
	'copy': 'copiar',
	'pre production weeks': 'semanas pre producción',
	'production weeks': 'semanas producción',
	'post production weeks': 'semanas post producción',
	'wrap weeks': 'semanas wrap',
	'work days per week': 'días de trabajo en semana',
	'emitions per week': 'emisiones por semana',
	'air weeks': 'semanas al aire',
	'number units': 'número unidades',
	'with two cameras': 'con dos cámaras',
	'weeks and days': 'semanas y días',
	'unit weeks': 'semanas unidad',
	'calendar weeks': 'semanas calendario',
	'days/units': 'días/unidad',
	'calendar days': 'días calendario',
	'real production days': 'días reales de produción',
	'unit days': 'días unidad',
	'countries': 'países',
	'production countries': 'países producción',
	'international trips': 'viajes internacionales',
	'number of cities': 'número de ciudades',
	'national trips': 'viajes nacionales',
	'round trip': 'ida y vuelta',
	'non work days': 'días de no trabajo',
	'opening and promotions (EPK)': 'cortinilla y promociones(EPK)',
	'international displacements': 'desplazamientos internacionales',
	'national displacements': 'desplazamientos nacionales',
	'holidays': 'festivos',
	'free saturdays': 'sábados libres',
	'planning meetings': 'reuniones de plan',
	'name city': 'nombre ciudad',
	'days to reduce': 'días a reducir',
	'percent': 'porcentaje',
	'minutes per chapter': 'minutos por capítulo',
	'margin': 'margen',
	'material per chapter': 'material por capítulo',
	'maximum minutes to produce': 'máximos minutos a producir',
	'reference minutes to produce daily': 'referencia minutos a producir diario',
	'reference scenes to produce daily on location': 'referencia escenas a producir diario en locación',
	'reference scenes to produce daily studio': 'referencia escenas a producir diario estudio',
	'average minutes to produce daily': 'promedio minutos a producir diario',
	'average': 'promedio',
	'average scenes to produce daily location': 'promedio escenas a producir diario locación',
	'average scenes to produce daily studio': 'promedio escenas a producir diario estudio',
	'maximum scenes': 'maximas escenas',
	'scenes to reduce in chapter': 'escenas a reducir por capítulo',
	'maximum scenes to produce': 'escenas máximas a producir',
	'reference scenes to produce daily': 'referencia escenas a producir diarias',
	'opening and promotions (epk)': 'cortinilla y promociones (EPK)',
	'average scenes to produce daily': 'promedio escenas a producir diarias',
	'minimum per chapter': 'mínimo por capítulo',
	'shooting schedule scenes': 'escenas plan diario',
	'shooting schedule scenes on location': 'escenas plan diario en locación',
	'shooting schedule scenes on studio': 'escenas plan diario en estudio',
	'lead actors participation': 'participación actor principal',
	'lead actor daily participation': 'participación diaria actor principal',
	'lead actor daily scenes': 'escenas diaria actor principal',
	'lead actor daily scenes location': 'escenas diarias actor principal en locación',
	'lead actor daily scenes studio': 'escenas diarias actor principal en estudio',
	'lead actor non work days': 'días de no trabajo actor principal',
	'maximum scenes on location with lead actor': 'escenas máximas con actor principal en locación',
	'maximum scenes on studio with lead actor': 'escenas máximas con actor principal en estudio',
	'maximum scenes with lead actor': 'escenas máximas con actor principal',
	'maximum scenes in chapters with lead actor': 'escenas máximas con actor principal por capítulo',
	'maximum participation lead actor': 'participación actor principal',
	'calendar days lead actor': 'días calendario actor principal',
	'other actors': 'otros actores',
	'supporting actors (atl)': 'actores secundarios (atl)',
	'guest stars': 'actores invitados',
	'day players': 'figurantes',
	'extra large': 'extra grande',
	'large': 'grandes',
	'medium': 'mediano',
	'small': 'pequeño',
	'in serie': 'en la serie',
	'per chapter': 'por capítulo',
	'budget locations': 'locaciones presupuestadas',
	'average new locations': 'promedio nuevas locaciones',
	'maximum written locations': 'máximas escenas escritas',
	'difference written vs budget': 'diferencia escritas y presupuestadas',
	'locations with lead': 'locaciones con principal',
	'rate exchange': 'tipo de cambio',
	'working unit days': 'días trabajo unid',
	'non working unit days': 'días no trabajo unid',
	'real working unit days': 'días reales trabajo unid',
	'ref minutes daily': 'ref minutos diarios',
	'avg minutes daily': 'prom minutos diarios',
	'ref scenes daily': 'ref escenas diarias',
	'real scenes daily': 'real escenas diarias',
	'previous shooting': 'planes anteriores',
	'todays shooting': 'planes hoy',
	'actual scenes': 'escenas actuales',
	'actual minutes': 'minutos actuales',
	'proj scn': 'esc proy',
	'diff': 'dif',
	'post non used minutes': 'minutos post no usados',
	'real difference minutes': 'diferencia real minutos',
	'bud scn': 'esc pres',
	'real scn': 'esc real',
	'bud min': 'min pres',
	'real min': 'min real',
	'daily avergae': 'promedio diario',
	'difference': 'diferencia',
	'new average': 'nuevo promedio',
	'extra days': 'días extras',
	'one or more scenes belong to an recording shooting schedule': 'una o más escenas perteneces a un plan diario grabando',
	'there is a shooting schedule already closed for the date and unit selected': 'hay un plan diario cerrado en la fecha seleccionada',
	'this scene number already exist on this chapter': 'este número de escena ya existe en el capítulo',
	'this scenes has been assigned to a shooting schedule, an cannot be deleted': 'esta escena ha sido asignada a un plan diario y no puede ser borrada',
	'character roles': 'roles personajes',
	'filter characters': 'filtrar personajes',
	'edit character': 'editar personaje',
	'change talent': 'cambiar actor',
	'remove talent': 'desasignar actor',
	'artistic name': 'nombre artístico',
	'download report': 'descargar reporte',
	'edit location': 'editar locaciones',
	'1st chap': '1er cap',
	'%scn.': '%esc',
	'scn.': 'esc',
	'c scn.': 'c esc.',
	'edit set': 'editar set',
	'delete set': 'eliminar set',
	'category element': 'categoría elemento',
	'1st chap.': '1er cap',
	'shooting schedule reports': 'reporte plan diario',
	'call sheet': 'llamado diario',
	'scn prod': 'prod esc',
	'written scenes': 'escenas escritas',
	'maximum written scenes': 'máximo escenas escritas',
	'night exterior scenes': 'escenas noche exterior',
	'calculated': 'calculado',
	'maximum written': 'máximo escrito',
	'differnece written vs budget': 'diferencia escritas vs presupuestadas',
	'scenes per chapter': 'escenas por capítulo',
	'days per episode': 'días por episodio',
	'breakdown': 'desglose',
	'actual difference': 'diferencia actual',
	'projection': 'proyección',
	'projected difference': 'diferencia proyectada',
	'scn': 'esc',
	'ch': 'cap',
	'ch scn': 'esc cap',
	'ch min': 'min cap',
	'totals': 'totales',
	'daily average': 'promedio diario',
	'extra shootings': 'llamados extras',
	'january': 'enero',
	'february': 'febrero',
	'march': 'marzo',
	'april': 'abril',
	'may': 'mayo',
	'june': 'junio',
	'july': 'julio',
	'augost': 'agosto',
	'september': 'septiembre',
	'october': 'octubre',
	'november': 'noviembre',
	'december': 'diciembre',
	'create holiday': 'crear feriado',
	'character not available': 'personaje no disponible',
	'location not available': 'Locación no disponible',
	'add unit event': 'Agregar evento unidad',
	'available': 'Disponible',
	'not available': 'no disponible',
	'remove unit': 'eliminar unidad',
	'select option': 'seleccionar',
	'set available': 'marcar disponible',
	'remove holiday': 'eliminar feriado',
	'received_abb': 'rec',
	'cancel_abb': 'can',
	'difference_abb': 'dif',
	'cummulative_difference_abb': 'dif acum',
	'assigned_abb': 'plan',
	'budget_abb': 'pres',
	'retakes_abb': 'rep',
	'non_effective_abb': 'no efe',
	'effective_abb': 'efe',
	'budget_chapters_abb': 'cap pres',
	'budget_scenes_abb': 'esc pres',
	'budget_minutes_abb': 'min pres',
	'effective_difference_abb': 'dif efe',
	'set shooting as private': 'Cambiar plan a privado',
	'set shooting as tentative': 'Cambiar plan a tentativo',
	'all produced scenes will become unproduce': 'todas las escenas producidas se desproduciran',
	'cum_projected_abb': 'proj',
	'cum_received_abb': 'rec',
	'cum_difference_abb': 'dif',
	'cum_chapters_projected_abb': 'Acu cap proj',
	'cum_chapters_received_abb': 'Acu cap rec',
	'cum_chapters_difference_abb': 'Acu cap dif',
	'week': 'Semana',
	'weekly chapyters': 'Capítulos semanales',
	'cumm chapters': 'Capítulos Acum',
	'weekly scenes': 'Escenas semanales',
	'cummulative scenes': 'Escenas acumuladas',
	'cummulative chapters': 'Capítulos acumulados',
	'weekly minutes': 'minutos semanales',
	'cummulative minutes': 'minutos acumulados',
	'proj ch': 'cap proy',
	'rec ch': 'cap rec',
	'ch diff': 'dif cap',
	'prod scn': 'esc prod',
	'can scn': 'esc can',
	'rep scn': 'esc rep',
	'scn diff': 'dif esc',
	'eff scn diff': 'dif efe esc',
	'can min': 'min can',
	'min diff': 'dif min',
	'eff min dif': 'dif efe min',
	'is not available on this date': 'no esta disponible en esta fecha',
	'for this unit on this date': 'para esta unidad en esta fecha',
	'sets reports': 'reportes sets',
	'sets report': 'reporte sets',
	'set in chapters': 'sets en capítulos',
	'elements reports': 'reportes elementos',
	'elements report': 'reporte elementos',
	'element in chapters': 'elementos en capítulos',
	'chapters parameters': 'Parámetros de capítulos',
	'chapter parameters': 'Parámetros de capítulo',
	'characters detail': 'Detalle de personajes',
	'locations detail': 'Detalle de locaciones',
	'events detail': 'Detalle de eventos',
	'characters parameters': 'Parámetros de personajes',
	'locations parameters': 'Parámetros de locaciones',
	'events parameters': 'Parámetros de eventos',
	'sets': 'sets',
	'per ch': 'x cap',
	'avg': 'prom',
	'pages per chapter': 'páginas por capítulo',
	'written scenes per chapter': 'escenas escritas por capítulo',
	'breakdown scenes per chapter': 'escenas sadas por capítulo',
	'breakdown scenes and protections per chapter': 'escenas y protecciones desglosadas por capítulo',
	'pages difference': 'diferencia páginas',
	'written scenes difference': 'diferencia escenas escritas',
	'breakdown scenes difference': 'diferencia escenas desglosadas',
	'content parameters': 'parámetros de contenido',
	'written minutes difference': 'diferencia minutos escritos',
	'written minutes': 'minutos escritos',
	'manually produced': 'producido manual',
	'manually produced minutes': 'minutos producidos manual',
	'minutes to produce': 'minutos a producir',
	'minutes to produce difference': 'diferencia minutos a producir',
	'manually produced scenes': 'escenas producidas manual',
	'scenes to produce': 'escenas a producir',
	'scenes parameters': 'parámetros escenas',
	'scenes day': 'escenas día',
	'scenes night': 'escenas noche',
	'scenes interior': 'escenas interior',
	'scenes exterior': 'escenas exterior',
	'scenes interior day': 'escenas interior día',
	'scenes exterior day': 'escenas exterior día',
	'scenes interior night': 'escenas interior noche',
	'scenes exterior night': 'escenas exterior noche',
	'cast parameters': 'parámetros talento',
	'lead and supporting cast playing': 'participación personajes principales y secundarios',
	'new characters lead and supporting cast': 'nuevos personajes principales y secundarios',
	'lead and supporting cast difference': 'diferencia personajes principales y secundarios',
	'guest stars playing': 'participación actores invitados',
	'new guest stars': 'nuevos actores invitados',
	'guest star difference': 'diferencia actores invitados',
	'day players playing': 'participación figurantes',
	'new day players': 'nuevos figurantes',
	'day players difference': 'diferencia figurantes',
	'extras playing': 'participación extras',
	'new extras': 'nuevos extras',
	'extras difference': 'diferencia extras',
	'stunts playing': 'participación stunt',
	'new stunts': 'nuevos stunts',
	'stunts difference': 'diferencia stunts',
	'characters with out role': 'personajes sin rol',
	'production parameteres': 'parámetros de producción',
	'new locations': 'nuevas locaciones',
	'playing locations': 'locaciones en episodio',
	'aircrafts': 'aeronaves',
	'songs': 'canciones',
	'new locations difference': 'diferencia nuevas locaciones',
	'small events': 'eventos pequeños',
	'medium events': 'eventos medianos',
	'large events': 'eventos grandes',
	'extra large events': 'eventos extra grandes',
	'song': 'canción',
	'filter elements': 'filtrar elementos',
	'categories': 'categorías',
	'there are no results to show': 'no hay resultados para este filtro',
	'elements in chapters': 'elementos en capítulos',
	'songs in chapters': 'canciones en capítulos',
	'songs reports': 'reportes canciones',
	'edit song': 'editar canción',
	'songs report': 'reporte canciones',
	'in development': 'En desarrollo',
	'set as new': 'marcar como nuevo',
	'set in development': 'marcar como en desarollo',
	'set finished / bougth': 'marcar como finalizado / comprado',
	'interfaces in chapters': 'interfaces en capítulos',
	'interfaces reports': 'reportes interfaces',
	'interfaces report': 'reporte interfaces',
	'edit interface': 'editar interface',
	'event types': 'tipos evento',
	'production parameters': 'parámetros producción',
	'weekly sumary': 'resumen semanal',
	'asg scn': 'esc asi',
	'asg min': 'min asi',
	'weeks': 'semanas',
	'participation': 'Participación',
	'eff scn': 'esc efe',
	'eff min': 'min efe',
	'eff min diff': 'dif min efe',
	'view totals': 'ver totales',
	'day.': 'días',
	'event': 'evento',
	'edit event': 'editar evento',
	'delete event': 'eliminar evento',
	'add event': 'Agregar evento',
	'scenes_assigned_abb': 'esc asi',
	'scenes_produced_abb': 'esc prod',
	'produced_minutes_abb': 'min prod',
	'daily_produced_scenes_average_abb': 'esc p día',
	'edit unit': 'editar unidad',
	'delete unit': 'borrar unidad',
	'number': 'número',
	'name': 'nombre',
	'story country': 'País historia',
	'production country': 'País producción',
	'synopsis': 'Sinopsis',
	'pitched to': 'Presentado a',
	'next steps / deadline': 'Siguientes pasos',
	'tentative dates': 'Fechas tentativas',
	'edit project': 'editar proyecto',
	'delete project': 'eliminar proyecto',
	'budget episode': 'Presupuesto episodio',
	'scenes per day': 'escenas por día',
	'100% completed': '100% completado',
	'next steps': 'siguientes pasos',
	'holiday': 'feriado',
	'weekly chapters': 'capítulos semanales',
	'projected chapters': 'capítulos proyectados',
	'projected scenes': 'escenas proyectadas',
	'projected minutes': 'minutos proyectados',
	'view chapter': 'ver capítulo',
	'days to comment': 'días para comentar',
	'version': 'versión',
	'complete': 'completar',
	"brand": "marca",
	"brands": "marcas",
	'there are no images to show': 'No hay imágenes para mostrar ',
	'there are no cash advances created': 'No hay anticipos creados',
	'add images': 'agregar imágenes',
	'edit brand': 'editar marca',
	'previous': 'anterior',
	'next': 'siguiente',
	'uploaded': 'subido',
	'new scene': 'nueva escena',
	'characters reports': 'Reportes personajes',
	'characters report': 'Reporte personajes',
	'characters in chapters': 'Personajes en capítulos',
	'generating': 'Generando',
	'uploading': 'subiendo',
	'locations reports': 'Reportes locaciones',
	'locations report': 'Reporte locaciones',
	'locations in chapters': 'Locaciones en capítulos',
	'finance': 'finanzas',
	'add nearest hospital': 'agregar hospital cercano',
	'produced minutes': 'minutos producidos',
	'start shooting': 'inicio de grabación',
	'end shooting': 'fin de grabación',
	'script report': 'reporte de script',
	'link scenes': 'escenas vinculadas',
	'linked scenes': 'escenas vinculadas',
	'shoot description': 'descripción de la toma',
	'director notes': 'notas del director',
	'selected': 'seleccionado',
	'no brands added to this scene': 'no hay marcas agregadas a esta escena',
	'there are no characters created': 'no hay personajes creados',
	'script report template': 'plantilla reporte de script',
	'talent call template': 'plantilla llamado talento',
	'crew call template': 'plantilla llamado crew',
	'upload template': 'subir plantilla',
	'upload': 'subir',
	'there was an error with the following scenes': 'hubo un error en las siguientes escenas',
	'there was an error with the following clips': 'hubo un error en los siguientes clips',
	'move': 'mover',
	'publish shooting': 'publicar plan diario',
	'close shooting': 'cerrar plan diario',
	're open shooting': 'reabrir plan diario',
	'move shooting schedule': 'mover plan diario',
	'cancel shooting schedule': 'cancelar plan diario',
	'weekly shootings report': 'reporte semanal planes diarios',
	'general parameters': 'parámetros generales',
	'continuity characters': 'continuidad personajes',
	'continuity character': 'continuidad personaje',
	'continuity days': 'continuidad días',
	'continuity sets': 'continuidad sets',
	'continuity day': 'continuidad día',
	'all images': 'todas las imágenes',
	'all images sets': 'imágenes sets',
	'all images characters': 'imágenes personajes',
	'there are no results': 'No hay resultados',
	'not started': 'no iniciado',
	'closed': 'cerrado',
	'open': 'abierto',
	'number of characters': 'número de personajes',
	'there are no elements created': 'no hay elementos creados',
	'delete brand': 'borrar marca',
	'post production': 'post producción',
	'add brand': 'agregar marca',
	'prod center': 'centro prod',
	'pre prod start': 'inicio pre prod',
	'prod start': 'inicio prod',
	'prod end': 'fin prod',
	'post start': 'inicio post',
	'post end': 'fin post',
	'add crew': 'Agregar crew',
	'edit crew': 'Editar crew',
	'there is no crew created': 'No hay crew creado',
	'activate': 'activar',
	'deactivate': 'desactivar',
	'delete crew': 'eliminar crew',
	'logout': 'cerrar sesión',
	'change image': 'cambiar imagen',
	'upload project image': 'subir imagen del proyecto',
	'potential clients': 'clientes potenciales',
	'client feedback': 'feedback cliente',
	'completed': 'completado',
	'create scene': 'crear escena',
	'copy from scene': 'copiar desde escena',
	'real working unit days loc': 'días reales de trabajo loc',
	'real working unit days std': 'días reales de trabajo est',
	'filter locations': 'filtrar locaciones',
	'filter sets': 'filtrar sets',
  'catering': 'comida',
	'add catering': 'agregar catering',
	'name - job': 'nombre - cargo',
	'general producer': 'productor general',
	'summary report': 'reporte resumido',
	'daily scenes detail report': 'reporte detalle escenas diarias',
	'user type': 'tipo usuario',
	'uncancel': 'descancelar',
	'productions': 'producciones',
	'un cancel shooting schedule': 'descancelar plan diario',
	'uncancel shooting schedule': 'descancelar plan diario',
	'delete shooting schedule': 'borrar plan diario',
	'continuity set': 'continuidad set',
	'written scenes on location': 'escenas escritas en locacion',
	'written scenes on studio': 'escenas escritas en estudio',
	'written scenes on location difference': 'diferencia escenas escritas en locación',
	'written scenes on studio difference': 'diferencia escenas escritas en estudio',
	'breakdown scenes on location per chapter': 'escenas desglosadas en locación por capítulo',
	'breakdown scenes on studio per chapter': 'escenas desglosadas en estudio por capítulo',
	'breakdown scenes on location difference': 'escenas desglosadas en locación',
	'breakdown scenes on studio difference': 'escenas desglosadas en estudio',
	'first call': 'primer llamado',
	'calls': 'llamados',
	'there are no logs created on this shooting schedule': 'No hay registros creados en este plan diario',
	'production start': 'inicio producción',
	'upload character image': 'subir imagen de personaje',
	'none': 'ninguno',
	'events reports': 'reportes eventos',
	'events report': 'reporte eventos',
	'edit continuity image': 'Editar imagen continuidad',
	'phone': 'teléfono',
	'production coordinator': 'coordinador de producción',
	'line producer': 'productor de línea',
	'production office': 'oficina de producción',
	'photographer': 'fotografía',
	'production manager': 'gerente de producción',
	'publish tentative': 'publicar tentativo',
	'as tentative': 'como tentativo',
	'tentative name': 'nombre tentativo',
	'unassign scene': 'desasignar escena',
	'tentative': 'tentativo',
	'tentatives': 'tentativos',
	'published shootings': 'planes publicados',
	'tentative lunch': 'tentativo almuerzo/comida',
	'requirments calls': 'llamado requerimientos',
	'crew call': 'llamado crew',
	'on loc': 'en loc',
	'set as tentative': 'mover a tentativo',
	'pre-breakdown': 'pre desgloce',
	'private': 'privada',
	'not assigned': 'no asignada',
	'assigned': 'asignada',
	'produced assigned': 'producida asignada',
	'repetition': 'repetición',
	'not assigned protection': 'protección no asignada',
	'assigned protection': 'protección asignada',
	'produced protection': 'protección producida',
	'sides report': 'reporte de sides',
	'filter budget': 'filtrar presupuesto',
	'amount': 'cantidad',
	'delete budget': 'eliminar presupuesto',
	'account codes': 'códigos de cuenta',
	'description english': 'descripción inglés',
	'description spanish': 'descripción español',
	'code': 'código',
	'childs': 'hijos',
	'edit account code': 'editar código de cuenta',
	'add account code': 'agregar código de cuenta',
	'parent': 'padre',
	'account code': 'código de cuenta',
	'add child': 'agregar hijo',
	'project': 'proyecto',
	'currency': 'moneda',
	'wbs name': 'nombre wbs',
	'phase': 'fase',
	'edit wbs': 'editar wbs',
	'wbs type': 'tipo wbs',
	'create budget': 'crear presupuesto',
	'import budget': 'importar presupuesto',
	'account': 'Cuenta',
	'pre production': 'pre producción',
	'production': 'producción',
	'surname': 'apellido',
	'new user': 'nuevo usuario',
	'insert email': 'agregar email',
	'given names': 'nombre',
	'edit user': 'editar usuario',
	'delete user': 'eliminar usuario',
	'new budget': 'nuevo presupuesto',
	'commited': 'comprometido',
	'actuals': 'actuales',
	'expend': 'gastado',
	'avl': 'disp',
	'bud': 'pre',
	'cash advance detail': 'Detalle anticipos',
	'add invoice': 'agregar factura',
	'base cost': 'costo base',
	'taxes': 'impuestos',
	'concept': 'concepto',
	'requested by': 'solicitado por',
	'value': 'valor',
	'approval': 'aprobación',
	'there are no previous requests': 'no hay solicitudes anteriores',
	'invoices': 'facturas',
	'invoice': 'factura',
	'cash advance': 'anticipo',
	'submit': 'enviar',
	'to legalize': 'para legalizar',
	'approvals': 'aprobaciones',
	'review': 'revisión',
	'on review': 'en revisión',
	'view detail': 'ver detalle',
	'request': 'solicitar',
	'cash advance request': 'solicitud de anticipo',
	'open request': 'abrir solicitud',
	'there are no invoices created': 'no hay facturas creadas',
	'previous request': 'solicitides anteriores',
	'requested': 'solicitado',
	'approve': 'aprobar',
	'reject': 'Rechazar',
	'filter cash advances': 'filtrar anticipos',
	'departments': 'departamentos',
	'vendors': 'proveedores',
	'edit request': 'editar solicitud',
	'edit invoice': 'editar factura',
	'invoice number': 'número factura',
	'vendor type': 'tipo proveedor',
	'vendor name': 'nombre proveedor',
	'vendor document': 'documento proveedor',
	'vendor document or number': 'documento o número proveedor',
	'vendor number': 'número proveedor',
	'vendor code': 'código proveedor',
	're open': 'reabrir',
	'retentions': 'retenciones',
	'vendor detail': 'detalle proveedor',
	'vendor documents': 'documentos proveedor',
	'document': 'documento',
	'production center': 'centro de producción',
	'cost': 'costo',
	'retention tax': 'impuesto de retención',
	'center': 'centro',
	'drag and drop here or click to browse files': 'arrastra o haz clic aca para agregar archivos',
	'last call': 'último llamado',
	'scenes participation': 'participación de escenas',
	'history days': 'días de historia',
	'prod chapters': 'capítulos prod',
	'closed days': 'días cerrados',
	'scene header': 'Título escena',
	'location or set': 'Locación o set',
	'chapter #': '# Capítulo',
	'contract #': '# Contrato',
	'job / service name': 'nombre de trabajo / servicio',
	'job / service description': 'descripción de trabajo / servicio',
	'type of contract': 'tipo de contrato',
	'payment type': 'tipo de pago',
	'sign date': 'fecha de firma',
	'cost stm': 'costo stm',
	'files': 'archivos',
	'add contract': 'agregar contrato',
	'contract': 'contrato',
	'contracts': 'contratos',
	'cost per statement': 'costo por statement',
	'there are no comments': 'no hay comentarios',
	'contract number': 'número de contrato',
	'no files added': 'no hay archivos agregados',
	'scenes to produce daily on location': 'Escenas a producir diario en locación',
	'scenes to produce daily on studio': 'Escenas a producir diario en estudio',
	'minutes to produce daily on location': 'Minutos a producir diarios en locación',
	'minutes to produce daily on studio': 'Minutos a producir diarios en estudio',
	'minutes daily loc': 'min loc diarios',
	'minutes daily std': 'min estd diarios',
	'scenes daily loc': 'esc loc diarios',
	'scenes daily std': 'esc estd diarios',
	'chap': 'cap',
	'others': 'otros',
	'original design': 'diseño original',
	'there was an error duplicating this project': 'hubo un error al duplicar este proyecto',
	'ubication': 'ubicación',
	'there are no brands created': 'no hay marcas creadas',
	'brands report': 'reporte de marcas',
	'brands in chapters': 'marcas en capítulos',
	'duplicating project': 'duplicando proyecto',
	'duplicated project': 'proyecto duplicado',
	'duplicate project': 'duplicar proyecto',
	'periphery': 'periferia',
	'filter services': 'filtrar servicios',
	'add purchase order': 'agregar orden de compra',
	'service': 'servicio',
	'add files': 'agregar archivos',
	'delete service': 'eliminar servicio',
	'delete file': 'eliminar archivo',
	'take': 'toma',
	'plane': 'plano',
	'shot': 'plano',
	'camera': 'camara',
	'clip note': 'notas clip',
	'director note': 'notas director',
	'ingested': 'ingestado',
	'not found': 'no encontrado',
	'services template': 'plantilla servicios',
	'mark as pending': 'marcar como pendiente',
	'mark as new': 'marcar como nuevo',
	'mark on process': 'marcar como en proceso',
	'on process': 'en proceso',
	'edit purchase order': 'editar orden de compra',
	'purchase order': 'orden de compra',
	'edit catering': 'editar catering',
	'delete catering call': 'eliminar llamada de catering',
	'monthly service': 'servicio mensual',
	'monthly': 'mensual',
	'include monthly services': 'incluir servicios mensuales',
	'left over': 'merma',
	'chapters color box': 'caja de color capítulos',
	'edited': 'editada',
	'brands usage': 'uso de marcas',
	'brands per chapter': 'marcas por capítulo',
	'add role': 'agregar rol',
	'add type': 'agregar tipo',
	'new clips': 'clips nuevos',
	'ingested clips': 'clips ingestados',
	'synced clips': 'clips sincronizados',
	'not found clips': 'clips no encontrados',
	'camera position': 'posición de la cámara',
	'weekly days': 'días por semana',
	'approved': 'aprobado',
	'submitted': 'publicado',
	'legalize': 'legalizar',
	'legalized': 'legalizado',
	'partial legalized': 'legalizado parcial',
	'rejected': 'rechazado',
	'banking expenses': 'gastos bancarios',
	'create cash advance for a vendor': 'crear anticipo para un proveedor',
	'support file': 'archivo de soporte',
	'support files': 'archivos de soporte',
	'download document guide': 'descargar documento guia',
	'max chapters': 'max capítulos',
	'there is no shooting schedule on date selected': 'no hay plan diario en la fecha seleccionada',
	'submitted by': 'publicado por',
	'are you sure you want to submit': '¿Está seguro que quiere publicar?',
	'$submit': 'publicar',
	'services on this daily plan are not submitted': 'Los servicios de este plan diario no han sido publicados',
	'caterings on this daily plan are not submitted': 'Los caterings de este plan diario no han sido publicados',
	'beneficiary': 'beneficiario',
	'delete invoice': 'eliminar factura',
	'delete cash advance': 'eliminar anticipo',
	'submit cash advance': 'enviar anticipo',
	'invoices summary': 'Resumen facturas',
	'invoices detail': 'Detalle facturas',
	'update vendors': 'actualizar proveedores',
	'deposit': 'consignación',
	'new invoice': 'nueva factura',
	'paid value': 'valor pagado',
	'base value': 'valor (base)',
	'total value invoice': 'valor total factura',
	'approve all': 'aprobar todos',
	'date new': 'fecha nuevo',
	'date submitted': 'fecha publicado',
	'date approved': 'fecha aprobado',
	'date review': 'fecha revisado',
	'date legalized': 'fecha legalizado',
	'date rejected': 'fecha rechazado',
	'reject cash advance': 'rechazar anticipo',
	'there are no cash advances to show': 'no hay anticipos por mostrar',
	'reports': 'reportes',
	'download': 'descargar',
	'requested date from': 'fecha solicitado desde',
	'requested date to': 'fecha solicitado hasta',
	'approved date from': 'fecha aprobado desde',
	'approved date to': 'fecha aprobado hasta',
	'rejected date from': 'fecha rechazado desde',
	'rejected date to': 'fecha rechazado hasta',
	'legalized date from': 'fecha legalizado desde',
	'legalized date to': 'fecha legalizado hasta',
	'without': 'sin',
	'with': 'con',
	'chapters list': 'lista capítulos',
	'scenes list': 'lista escenas',
	'protections list': 'lista protecciones',
	'date created': 'fecha creado',
	'date updated': 'fecha actualizado',
	'all rights reserved': 'todos los derechos reservados',
	'add comment': 'agregar comentario',
	'insert date': 'agregar fecha',
	'to': 'a',
	'of': 'de',
	'add physical locations': 'agregar locaciones físicas',
	'view script': 'ver script',
	'add clip': 'agregar clip',
	'edit clip': 'editar clip',
	'selected clip': 'clip seleccionado',
	'edit service': 'editar servicio',
	'edit call': 'editar llamado',
	'edit comment': 'editar comentario',
	'delete call': 'eliminar llamado',
	'delete radio': 'eliminar radio',
	'delete comment': 'eliminar comentario',
	'delete clip': 'eliminar clip',
	'production roles': 'roles de producción',
	'general roles': 'roles generales',
	'add user': 'agregar usuario',
	'project user type': 'tipo de usuario proyecto',
	'name english': 'nombre inglés',
	'name spanish': 'nombre español',
	'edit role': 'editar rol',
	'edit type': 'editar tipo',
	'delete account code': 'eliminar código cuenta',
	'vendor types': 'tipos de proveedor',
	'vendor type name': 'nombre tipo proveedor',
	'add vendor type': 'agregar tipo proveedor',
	'edit vendor type': 'editar tipo proveedor',
	'delete type': 'eliminar tipo',
	'document guide': 'documento guia',
	'document name': 'nombre documento',
	'document description': 'descripción documento',
	'mandatory': 'obligatorio',
	'add vendor document': 'agregar documento proveedor',
	'edit vendor document': 'editar documento proveedor',
	'delete vendor docuement': 'eliminar documento proveedor',
	'tax name': 'nombre impuesto',
	'add tax': 'agregar impuesto',
	'edit tax': 'editar impuesto',
	'delete tax': 'eliminar impuesto',
	'tax': 'impuesto',
	'tax options': 'opciones impuestos',
	'tax option name': 'nombre opción impuesto',
	'sap indicator': 'indicador sap',
	'edit tax option': ' editar opción impuesto',
	'add tax option': ' agregar opción impuesto',
	'delete tax option': 'eliminar opción impuesto',
	'cash advance approvals': 'aprobaciones anticipos',
	'approval name': 'nombre aprobación',
	'cash advance approval name': 'nombre aprobación anticipo',
	'position': 'Posición',
	'edit cash advance approval': 'editar aprobación anticipo',
	'add cash advance approval': 'agregar aprobación anticipo',
	'send daily email': 'enviar correo diario',
	'delete cash advance approval': 'eliminar aprobación anticipo',
	'copy crew': 'copiar crew',
	'from previous shooting schedule': 'del plan diario anterior',
	'add shooting log': 'agregar bitácora plan diario',
	'edit shooting log': 'editar bitácora plan diario',
	'delete shooting log': 'eliminar bitácora plan diario',
	'add meal': 'agregar comida',
	'meal type': 'tipo comida',
	'time from': 'hora desde',
	'time to': 'hora hasta',
	'syncronized': 'sincronizado',
	'edit vendor': 'editar vendor',
	'documents': 'documentos',
	'delete catering': 'eliminar catering',
	'add cost': 'agregar costo',
	'legalize cash advance': 'legalizar anticipo',
	'reverse': 'revertir',
	'reject invoice': 'rechazar factura',
	'invoices files': 'Archivos de facturas',
	'mark on purchase order': 'marcar como orden de compra',
	'are you sure you want to mark this service as new?': '¿Está seguro de marcar este servicio como nuevo?',
	'are you sure you want to mark this catering as new?': '¿Está seguro de marcar este catering como nuevo?',
	'view script report': 'ver reporte script',
	'filter clips': 'filtrar clips',
	'on call': 'en llamado',
	'call to shooting': 'llamar al plan diario',
	'mark on call': 'marcar en llamado',
	'include on call sheet': 'incluir en llamado diario',
	'production centers': 'centros de producción',
	'delete production center': 'eliminar centro de producción',
	'are you sure you want to delete this production center?': '¿Está seguro de eliminar este centro de producción?',
	'add production center': 'agregar centro de producción',
	'edit production center': 'editar centro de producción',
	'office address': 'Dirección oficina',
	'add holiday': 'agregar festivo',
	'edit holiday': 'editar festivo',
	'delete holiday': 'eliminar festivo',
	'are you sure you want to delete this holiday': '¿Está seguro de eliminar este festivo?',
	'date start': 'fecha inicio',
	'add task': 'agregar tarea',
	'edit task': 'editar tarea',
	'add phase': 'agregar fase',
	'edit phase': 'editar fase',
	'edit phases': 'editar fases',
	'add phases': 'agregar fases',
	'delete task': 'eliminar tarea',
	'delete phase': 'eliminar fase',
	'task name': 'nombre tarea',
	'task unit': 'unidad tarea',
	'start at': 'empezar en',
	'predecessor': 'predecesor',
	'jump to start': 'saltar a inicio',
	'add break': 'agregar break',
	'edit break': 'editar break',
	'change duration': 'cambiar duración',
	'change quantity': 'cambiar cantidad',
	'apply change to following weeks': 'aplicar cambios a las semanas siguientes',
	'apply changes to following weeks': 'aplicar cambios a las semanas siguientes',
	'apply changes to following': 'aplicar cambios a las siguientes',
	'apply change to same week on following tasks': 'aplicar cambios a la misma semana en las siguientes tareas',
	'view project': 'ver proyecto',
	'read edl': 'leer edl',
	'episodes color box': 'caja de color episodios',
	'episode detail': 'detalle episodio',
	'rollback episode': 'retroceder episodio',
	'rotate image': 'rotar imagen',
	'add invoice number': 'Agregar número factura',
	'edit invoice number': 'Editar número factura',
	'add accounting': 'añadir la contabilidad',
	'edit accounting': 'editar la contabilidad',
	'accounting number': 'Número accounting',
	'costs': 'costos',
	'no matching record found': 'No se encontró ningún registro coincidente',
	'clear filters': 'Borrar filtros',
	'from': 'Desde',
	'history': 'Historial',
	'no records found': 'No hay registros',
	'view history': 'Ver historial',
	'merge characters': 'Unificar personajes',
	'into': 'en',
	'merge extras': 'Unificar extras',
	'merge sets': 'Unificar sets',
	'merge locations': 'Unificar locaciones',
	'merge elements': 'Unificar elementos',
	'bulk change': 'Cambios masivos',
	'show only selected by director': 'Mostrar solo seleccionado por el director',
	'no clips added to this scene': 'No se agregaron clips a esta escena',
	'invoice history': 'Historial factura',
	'service history': 'Historial servicio',
	'catering history': 'Historial catering',
	'legalize support': 'Soporte legalización',
	'action': 'Acción',
	'connecting to CI': 'Conectando al CI',
	'in consideration': 'En consideración',
	'in production': 'En producción',
  	'past project': 'proyecto pasado',
	'Login with ADFS': "Iniciar sesión con ADFS",
  	'Login with token': "Iniciar sesión con token",
	'transit': 'tránsito',
	'transit date': 'fecha de tránsito',
	'transit status': 'estado de tránsito',
	'transit repository': 'repositorio de tránsito',
	'rfd date': 'lpe fecha',
	'rfd status': 'lpe estado',
	'rfd repository': 'lpe repositorio',
	'copy from project': 'copiar de un proyecto',
	'new assets': 'nuevo asset',
	'task': 'tarea',
	'start': 'inicio',
	'asset name': 'nombre del asset',
	'client description': 'descripción del cliente',
	'ready for delivery': 'listo para entrega',
	'repository': 'repositorio',
	'reply': 'responder',
	'asset name eng': 'nombre del asset eng',
	'asset name esp': 'nombre del asset esp',
	'client description eng': 'descripción del cliente eng',
	'client description esp': 'descripción del cliente esp',
	'asset type': 'tipo de asset',
	'day/week': 'día/semana',
	'on': 'en',
	'view asset details': 'ver detalles asset',
	'edit asset': 'editar asset',
	'receive asset': 'recibir asset',
	'delete asset': 'eliminar asset',
	'asset on': 'asset en',
	'there are no comments to show': 'no hay comentarios para mostrar',
	'$week_initial': 'S',
	'add stripboard': 'Agregar Stripboard',
	'published date': 'Fecha publicación',
	'there are no stripboards created': 'No hay stripboards creados',
	'view stripboard': 'Ver stripboard',
	'edit stripboard': 'Editar Stripboard',
	'delete stripboard': 'Eliminar stripboard',
	'are you sure you want to delete this stripboard?': '¿Estás seguro de que quieres eliminar este stripboard?',
	'create stripboard': 'crear stripboard',
	'stripboard name': 'Nombre stripboard',
	'insert name': 'Ingrese Nombre',
	'detail stripboard': 'Detalle stripboard',
	'w': 's',
	's': 'e',
	'day int': 'día int',
	'day ext': 'día ext',
	'night int': 'noche int',
	'night ext': 'noche ext',
	'add week': 'Agregar semana',
	'add day': 'Agregar día',
	'warning': 'Advertencia',
	'the following scenes will not be removed from past shootings, but will be reassigned to a new one':'Las siguientes escenas no se eliminarán de los shootings anteriores, sino que se reasignarán a una nueva',
	'the following scenes will be removed from future shootings and assigned to a new one':'Las siguientes escenas se eliminarán de futuros shootings y se asignarán a una nueva',
	'the following scenes will be removed':'Las siguientes escenas serán eliminadas.',
	'progress': 'Progreso',
	'last response': 'Última respuesta',
	'something went wrong, please try again': 'Algo salió mal. Por favor, vuelva a intentarlo',
	'something went wrong': 'Algo salió mal',
	'are you sure you want to unpublish this stripboard?': '¿Estás seguro de que quieres despublicar este stripboard?',
	'unpublish': 'despublicar',
	'unpublish stripboard': 'Despublicar stripboard',
	'do you want to load information from current shootings?': '¿Quiere cargar información de los planes diarios actuales?',
	'yes': 'si',
	'abbreviation': 'abreviatura',
	'months': 'Meses',
	'project category': 'Categoría proyecto',
'click to add new material': 'Clic para agregar un nuevo material',
	'click to add new tentative cast': 'Clic para agregar un nuevo elenco tentativo',
	'click to add new potencial client': 'Clic para agregar un nuevo cliente potencial',
	'click to add new writer': 'Clic para agregar un nuevo escritor',
	'click to add new director': 'Clic para agregar un nuevo director',
	'click to add new pitch': 'Clic para agregar un nuevo tono',
	'click to add new step': 'Clic para agregar un nuevo paso',
	'duplicate': 'Duplicar',
	'This daily plan has not submit':'este plan diario no tiene submit',
	'No daily plan found:': 'no existen plan diario',
	'drag and drop image here or press to select from folder': 'Arrastre y suelte la imagen aquí o presione para seleccionar de la carpeta',

	'project name': 'Nombre del proyecto',
	'pre-production dates': 'fechas pre-producción',
	'production dates': 'fechas producción',
	'post-production dates': 'fechas post-producción',
	'delete production': 'eliminar producción',	
	'are you sure you want to delete': '¿Está seguro de eliminar',
	'config': 'configuración',
	'inactivate': 'inactivar',
	'statements': 'declaraciones',
	'click to add new project': 'Clic para agregar un nuevo proyecto',
	'post-production': 'Post-producción',
	'prod weeks': 'semanas prod',
	'scenes x episode': 'escenas x episodio',
	'scenes shot': 'escenas producidas',
	'pages x episode': 'páginas x episodio',
	'pages shot': 'páginas producidas',
	'shooting scn avg': 'Esc grabadas prom',
	'shooting pages avg': 'Pág grabadas prom',
	'shot scenes': 'Esc Grabadas',
	'shot pages': 'Pág Grabadas',
	'scheduled': 'programado',
	'cast': 'elenco',
	'more days needed': 'se necesitan más días',
	'no comments added to this scene': 'No se agregaron comentarios a esta escena',
	'pick up': 'Recoger',
	'there are no comments created on this shooting schedule': 'No hay comentarios creados en este horario de rodaje',
	'view both': 'Ver ambos',
	'there are no shooting schedule assigned to this scene': 'no hay horario de rodaje asignado a esta escena',
	"director's notes": 'Notas del director',
	'other characters': 'Otros personajes',
	'view character details': 'ver detalles de personaje',
	'add talent': 'agregar talento',
	'role': 'Rol',
	'view location details': 'ver detalles de locación',
	'day out of days': 'Días de trabajo',
	'view set details': 'Ver detalles de set',
	'upload location image': 'subir imagen de locación',
	'upload set image': 'subir imagen de set',
	'edit element': 'editar elemento',
	'view element details': 'Ver detalles de elemento',
	'upload element image': 'subir imagen de elemento',
	'are you sure you want to publish this stripboard': '¿Está seguro de publicar este stripboard',
	'select unit': 'Seleccionar unidad',
	'detail': 'detalle',
	'insert tentative': 'Agregar tentativo',
	'click to add new camera': 'clic para agregar nueva cámara',
	'sound view': 'sonido en vivo',
	'view others': 'ver otros',
	'sync': 'sinc',
	'view clip': 'ver clip',
	'reply comment': 'responder comentario',
	'approve asset': 'aprobar asset',
	'reject asset': 'rechazar asset',
	'invoices ly': 'facturas ly',
	'invoices lp': 'facturas lp',
	'undefined': 'undefinido',
	'on time': 'A tiempo',
	'due date': 'Próxima a vencer',
	'complete late': 'Completada tarde',
	'overdue': 'vencida',
	'weeks cannot be decreased': 'las semanas no se pueden disminuir',
	'user already exists': 'El usuario ya existe',
	'live view': 'vista en vivo',
	'live view users': 'live view - usuarios',
	'delete live view user': 'eliminar usuario de Live View',
	'are you sure you want to delete this live view user?': '¿está seguro de eliminar el usuario del live view?',
	'new': 'nuevo',
	'remove': 'remover',
	'move all to': 'Mover todo a',
	'technical analysis by scenes': 'Análisis técnico de escenas',
	'chapter script report': 'Reporte de script por capítulo',
	'items report': 'Reporte de elementos',
	'create category element': 'crear categoría de elemento',
	'category name english': 'Nombre de categoría Inglés',
	'category name spanish': 'Nombre de categoría Español',
	'category name potuguese': 'Nombre de categoría Portugués',
	'edit category': 'Editar categoría',
	'merge categories': 'unificar categorías',
	'delete category': 'Eliminar categoría',
	'not apply': 'No aplica',
	'are you sure to change the status to not apply?': '¿Está seguro de cambiar el estado a No Aplica?',
	'change status': 'cambiar estado',
	'category elements': 'Categorías de elementos',

	'pre prod weeks': 'Semanas pre prod',
	'post weeks': 'Semanas post', 
	'wrapp weeks': 'Semanas Wrapp',
	'% studio': '% estudio',
	'% location': '% locación',
	'location night': 'locación nocturna',
	'pages * episode': 'páginas * episodios',
	'avg pages * studio': 'prom pag * estudio',
	'avg pages * location': 'prom pag * loc',
	'avg pages * loc night': 'prom pag * loc noct',
	'scenes * episode': 'escenas * episodio',
	'scenes * studio': 'escenas * estudio',
	'scenes * location': 'escenas * locación',
	'scenes * loc night': 'escenas * loc noct',
	'1 ep pages': '1 ep páginas',
	'1 ep scenes': '1 ep escenas',
	'days per week': 'días por semana',
	'days calendar': 'días calendario',
	'real days': 'días reales',
	'real participation': 'participación real',
	'no working days': 'días de no trabajo',
	'prod meetings': 'reuniones prod',
	'minutes * episode': 'minutos * episodio',
	'minutes * studio': 'minutos * estudio',
	'minutes * location': 'minutos * locación',
	'minutes * loc night': 'minutos * loc noct',
	'add. non-working days': 'add. días no-trabajo',
	'total non working days': 'total días de no trabajo',
	'production trips': 'viajes de producción',
	'international trip': 'viaje internacional',
	'national trip': 'viaje nacional',
	'air weeks (5 days)': 'semanas al aire (5 días)',
	'max calls': 'max llamados',
	'shootings off': 'planes diarios off',
	'real shootings': 'planes diarios reales',
	'total pages': 'total páginas',
	'pages studio': 'páginas estudio',
	'pages location': 'páginas locación',
	'pages exterior night': 'páginas exterior noct',
	'total minutes': 'minutos totales',
	'minutes studio': 'minutos estudio',
	'minutes location': 'minutos locación',
	'minutes location night': 'minutos locación noct',
	'total scenes': 'total escenas',
	'scenes studio': 'escenas estudio',
	'scenes location': 'escenas locación',
	'scenes location night': 'escenas locación noct',
	'shootings studio': 'planes diarios estudio',
	'shootings location': 'planes diarios locación',
	'shootings location night': 'planes diarios locación noct',
	'pages * shooting': 'páginas * plan diario',
	'pages std * shooting': 'páginas std * plan diario',
	'pages * shooting exterior': 'páginas * plan diario ext',
	'pages * shoot ext night': 'pág * plan diario ext noct',
	'minutes * shooting': 'minutos por plan diario',
	'min std * shooting': 'min std * plan diairo',
	'min ext * shooting': 'min ext * plan diario',
	'min loc night * shooting': 'min loc noct * plan diario',
	'scenes * shootings': 'escenas * planes diarios',
	'scn std * shooting': 'esc std * plan diario',
	'scn ext * shooting': 'esc ext * plan diario',
	'scn loc night * shoot': 'esc loc noct * plan diario',
	'parameter values': 'Valores párametros',
	'totals according to parameters': 'Totales según parámetros',
	'deductible': 'deducible',
	'checked from': 'Comprobado desde',
	'checked to': 'Comprobado hasta',
	'invoice not created, invoice cost higher than expended value': 'Factura no creada, el costo de la factura es mayor que el valor gastado',
	'tax folio': 'Folio fiscal',
	'sap report mexico': 'Reporte SAP México',
	'date end': 'Fecha fin',
	'worked days': 'Días trabajados',
    'details': 'detalles',
	'current month': 'Mes actual',
	'all calendar': 'Todo el calendario',
	'show range': 'Mostrar rango',
	'change': 'cambio',
	'show character details': 'Mostrar detalles personaje',
	'hide character details': 'Ocultar detalles personaje',
	'production currencies': 'Divisas de la producción',
	'parameters/globals': 'Parámetros/Globales',
	'qty': 'cant',
	'groups': 'grupos',
	'budget units': 'unidades presupuesto',
	'no data available': 'No hay información disponible',
	'group': 'Grupo',
	'edit line': 'editar línea',
	'upload budget': 'cargar presupuesto',
	'grand total': 'gran total',
	'edit table': 'editar tabla',
	'add field': 'agregar campo',
	'save table': 'guardar tabla',
	'exchange': 'intercambio',
	'position matrix': 'matriz de cargos',
	'hiring detail': 'Detalle de contratación',
	'type hiring': 'Tipo de contratación',
	'confidence/ordinary': 'Confianza/Ordinario',
	'extra hours': 'Horas extra',
	'cop $ non premium': 'cop $ no premium',
	'income': 'ingreso',
	'cop $ non scripted from': 'cop $ no scripted desde',
	'cop $ non scripted to': 'cop $ no scripted hasta',
	'risk type': 'tipo de riesgo',
	'mxn $ non premium': 'cop $ no premium',
	'mxn $ non scripted from': 'cop $ no scripted desde',
	'mxn $ non scripted to': 'cop $ no scripted hasta',
	'upload position matrix': 'cargar matriz de cargos',
	'add position': 'Añadir cargo',
	'position detail': 'detalle del cargo',
	'role objective summary': 'Resumen de objetivos de rol',
	'edit field': 'editar campo',
	'essential title': 'Título esencial',
	'disered title': 'Título deseado',
	'work experience equivalent to essential degree': 'Años de experiencia equivalentes a título esencial',
	'years of work experience': 'Años de experiencia de trabajo',
	'personal skills': 'Habilidades personales',
	'technical skills': 'Habilidades técnicas',
	'computer skills': 'Habilidades de computación',
	'languages': 'Idiomas',
	'desired level': 'Nivel deseado',
	'reporting structure': 'estrucutra de reporte',
	'direct supervisor': 'Supervisor directo',
	'direct subordinates': 'Subordinados directos',
	'principal functions': 'Funciones principales',
	'mandatory compliance policy': 'Políticia de cumplimiento obligatorio',
	'specific knowledge and skills': 'Conocimientos y habilidades específicas',
	'edit detail': 'editar detalle',
	'delete detail': 'eliminar detalle',
	'summary': 'Resumen',
	'subordinate': 'Subordinado',
	'politics': 'Politicas',
	'desirable title': 'Título deseable',
	'budget master': 'Presupuesto maestro',
	'edit production currency': 'Editar divisa de la producción',
	'add production currency': 'Agregar divisa de la producción',
	'add parameter/global': 'Agregar Parámetro/Global',
	'edit parameter/global': 'Editar Parámetro/Global',
	'add group': 'Agregar Grupo',
	'edit group': 'Editar Grupo',
	'are you sure you want to reject this invoices?': '¿Está seguro de que quiere rechazar estas facturas?',
	'reject invoices': 'rechazar facturas',
	'initial spread': 'dispersión inicial',
	'the budget upload process is being carried out, when it is completed we will send you a notification to the registered email': 'Se está realizando el proceso de carga de presupuesto, cuando se complete le enviaremos una notificación al correo electrónico registrado',
	'all units': 'Unidades',
	'view table': 'ver tabla',
	'view list': 'ver lista',
	'filter project': 'filtrar proyecto',
	'prod country': 'País prod',
	'no streaming available': 'No hay streaming disponible',
	'g': 'M',
	'delete not used':'Eliminar no utilizados',
	'whitout':'Sin',
	'if you change this call, this will also change all related time':'Si cambia este llamado, también cambiará las horas relacionadas',
	'create chapter scenes':'Crear escenas de capítulo',
	'check the scenes you whant to delete all previous data otherwise system will only replace diferent values':'Marque las escenas que desea eliminar todos los datos anteriores de lo contrario el sistema solo reemplazará los valores diferentes',
	'create scenes': 'Crear escenas',
	'day/night': 'Día/Noche',
	'include as general comment': 'Incluir como comentario general',
	'catering status': 'Estado de comida',
	'service status': 'Estado de servicio',
	'minutes difference': 'diferencia de minutos',
	'scenes difference':'diferencia de escenas',
	'day scenes per chapter': 'Escenas día por capítulo',
	'night scenes per chapter': 'Escenas noche por capítulo',
	'interior scenes per chapter': 'Escenas interior por capítulo',
	'exterior scenes per chapter': 'Escenas exterior por capítulo',
	'interior day scenes per chapter':'Escenas interior día por capítulo',
	'interior night scenes per chapter':'Escenas interior noche por capítulo',
	'exterior day scenes per chapter':'Escenas exterior día por capítulo',
	'exterior night scenes per chapter':'Escenas exterior noche por capítulo',
	'location scenes per chapter':'Escenas locación por capítulo',
	'studio scenes per chapter':'Escenas estudio por capítulo',
	'location day scenes per chapter':'Escenas locación día por capítulo',
	'studio day scenes per chapter':'Escenas estudio día por capítulo',
	'location night scenes per chapter': 'Escenas locación noche por capítulo',
	'studio night scenes per chapter': 'Escenas estudio noche por capítulo',
	'add address': 'agregar dirección',
	'change address': 'cambiar dirección',
	'no address added to this location': 'no hay dirección agregada a esta locación',
	'production report':'Reporte producción',
	'service call':'Llamado servicios',
	'crossing characters':'cruce de personajes',
	'be aware that would be unassigned from the scenes on this shooting schedule they are currently in': 'tenga en cuenta que va a ser desasignado de las escenas en este plan diario que está participando',
	'budget types':'Tipos de presupuesto',
	'type budget':'Tipo de presupuesto',
	'only scripy scenes':'solo escenas libreto',
	'show script scenes':'mostrar escenas libreto',
	'show sub scenes':'mostrar sub escenas',
	'only sub scenes':'solo sub escenas',
	'script scenes':'escenas  libreto',
	'sub scenes':'sub escenas',
	'reset call':'reiniciar llamado',
	'consolidated logs report':'Reporte de bitácoras',
	'morning snack': 'merienda',
	'afternoon snack': 'merienda tarde',
	'wrap': 'cierre',
	'dinner': 'cena',
	'breakfast': 'desayuno',
	'are you sure you want to unpublish': '¿Está seguro de que desea despublicar',
	'scene images': 'imágenes de escena',
	'#': '#',
	'account group': 'grupo de cuenta',
	'accounting': 'contabilidad',
	'acct': 'cuenta',
	'act': 'acto',
	'actor': 'actor',
	'add account': 'agregar cuenta',
	'add asset': 'agregar activo',
	'add banner': 'agregar banner',
	'add clearing': 'agregar compensación',
	'add detail': 'agregar detalle',
	'add expense': 'agregar gasto',
	'add file': 'agregar archivo',
	'add goals': 'agregar metas',
	'add hijuela': 'agregar hijuela',
	'add item': 'agregar ítem',
	'add milestone': 'agregar hito',
	'add new': 'agregar nuevo',
	'add new hospital': 'agregar nuevo hospital',
	'add release': 'agregar lanzamiento',
	'add shooting time': 'agregar tiempo de rodaje',
	'add subaccount': 'agregar subcuenta',
	'add template': 'agregar plantilla',
	'add unit:': 'agregar unidad:',
	'add vendor': 'agregar proveedor',
	'add wbs': 'agregar wbs',
	'admin': 'administrador',
	'advance cash': 'anticipo de caja',
	'all categories': 'todas las categorías',
	'all rights reserved copyright': 'todos los derechos reservados',
	'all roles': 'todos los roles',
	'all years': 'todos los años',
	'an 8 digits token has been sent to': 'se ha enviado un token de 8 dígitos a',
	'apply change to following': 'aplicar cambio a siguientes',
	'are you sure you want to create budget from master?': '¿está seguro de crear presupuesto desde el maestro?',
	'are you sure you want to delete this detail?': '¿está seguro de eliminar este detalle?',
	'are you sure you want to delete this hospital?': '¿está seguro de eliminar este hospital?',
	'are you sure you want to delete this item?': '¿está seguro de eliminar este ítem?',
	'are you sure you want to delete this job?': '¿está seguro de eliminar este cargo?',
	'are you sure you want to upload budget? the data will be replace': '¿está seguro de cargar el presupuesto? los datos serán reemplazados',
	'asset name english': 'nombre del activo inglés',
	'asset name portuguese': 'nombre del activo portugués',
	'asset name spanish': 'nombre del activo español',
	'asset_name': 'nombre del activo',
	'assets': 'activos',
	'at': 'en',
	'banner': 'banner',
	'basecamp': 'campamento base',
	'blacks': 'negros',
	'brands reports': 'reportes de marcas',
	'break': 'pausa',
	'budget breakdown': 'desglose de presupuesto',
	'budget type': 'tipo de presupuesto',
	'calendar stripboard': 'calendario stripboard',
	'call place': 'lugar de llamado',
	'cameras': 'cámaras',
	'cancel chapter': 'cancelar capítulo',
	'cancel edit in line': 'cancelar edición en línea',
	'cancel prod': 'cancelar prod',
	'cancel selected scenes': 'cancelar escenas seleccionadas',
	'cancelada': 'cancelada',
	'card number': 'número de tarjeta',
	'cash advance approval': 'aprobación de anticipo',
	'caterings': 'caterings',
	'change call': 'cambiar llamado',
	'chapters differences': 'diferencias de capítulos',
	'characters on shooting': 'personajes en rodaje',
	'chat view': 'vista de chat',
	'clearing': 'compensación',
	'click here to generate a new token': 'haga clic aquí para generar un nuevo token',
	'click to add new function': 'clic para agregar nueva función',
	'click to add new unit': 'clic para agregar nueva unidad',
	'client description english': 'descripción del cliente inglés',
	'client description portuguese': 'descripción del cliente portugués',
	'client description spanish': 'descripción del cliente español',
	'comment change': 'comentario de cambio',
	'complete episode': 'completar episodio',
	'confidence': 'confianza',
	'configure': 'configurar',
	'confirm token': 'confirmar token',
	'continuidad': 'continuidad',
	'cover image': 'imagen de portada',
	'create role': 'crear rol',
	'crew': 'equipo técnico',
	'cuts': 'cortes',
	'daily email': 'correo diario',
	'day of history': 'día de historia',
	'days off': 'días libres',
	'deducible': 'deducible',
	'delete address': 'eliminar dirección',
	'delete banner': 'eliminar banner',
	'delete cash advance apporval': 'eliminar aprobación de anticipo',
	'delete chapter': 'eliminar capítulo',
	'delete character': 'eliminar personaje',
	'delete drawing': 'eliminar dibujo',
	'delete element': 'eliminar elemento',
	'delete hospital': 'eliminar hospital',
	'delete interface': 'eliminar interfaz',
	'delete item asset': 'eliminar ítem del activo',
	'delete job': 'eliminar cargo',
	'delete location': 'eliminar locación',
	'delete milestone': 'eliminar hito',
	'delete rol': 'eliminar rol',
	'delete selected scenes': 'eliminar escenas seleccionadas',
	'delete song': 'eliminar canción',
	'delete vendor': 'eliminar proveedor',
	'description portuguese': 'descripción portugués',
	'detail account': 'detalle de cuenta',
	'detail chapter': 'detalle del capítulo',
	'download file': 'descargar archivo',
	'download guide': 'descargar guía',
	'drawing note': 'nota de dibujo',
	'drawing notes': 'notas de dibujo',
	'duplicate holiday': 'duplicar festivo',
	'duration ranges': 'rangos de duración',
	'edit account': 'editar cuenta',
	'edit banner': 'editar banner',
	'edit budget': 'editar presupuesto',
	'edit category element': 'editar categoría de elemento',
	'edit clearing': 'editar compensación',
	'edit contract': 'editar contrato',
	'edit drawing': 'editar dibujo',
	'edit file': 'editar archivo',
	'edit milestone': 'editar hito',
	'edit position': 'editar posición',
	'edit rol': 'editar rol',
	'edit subaccount': 'editar subcuenta',
	'edit template': 'editar plantilla',
	'edl results': 'resultados EDL',
	'email': 'correo electrónico',
	'email address': 'dirección de correo',
	'end': 'fin',
	'enter comment': 'ingresar comentario',
	'enter notes...': 'ingresar notas...',
	'enter observation': 'ingresar observación',
	'ep': 'ep',
	'ep.': 'ep.',
	'error': 'error',
	'exchange rate': 'tasa de cambio',
	'exit full screen': 'salir de pantalla completa',
	'expenses': 'gastos',
	'export budget': 'exportar presupuesto',
	'failed': 'fallido',
	'feedback': 'retroalimentación',
	'filter assets': 'filtrar activos',
	'filter caterings': 'filtrar caterings',
	'filter vendors': 'filtrar proveedores',
	'filters': 'filtros',
	'flashback': 'flashback',
	'forecast': 'pronóstico',
	'frec': 'frec',
	'full screen': 'pantalla completa',
	'generate token': 'generar token',
	'group account': 'cuenta de grupo',
	'hide details': 'ocultar detalles',
	'hirings': 'contrataciones',
	'home': 'inicio',
	'hospital': 'hospital',
	'images': 'imágenes',
	'import fdx': 'importar fdx',
	'insert comment': 'insertar comentario',
	'insert day': 'insertar día',
	'interface': 'interfaz',
	'interfaces': 'interfaces',
	'interior / exterior': 'interior / exterior',
	'invalid camera name': 'nombre de cámara inválido',
	'invalid formula': 'fórmula inválida',
	'invalid login, please contact': 'inicio de sesión inválido, por favor contacte',
	'item': 'ítem',
	'live chat link': 'enlace de chat en vivo',
	'live view link': 'enlace de vista en vivo',
	'load': 'cargar',
	'load episode edl': 'cargar EDL del episodio',
	'login with okta': 'iniciar sesión con okta',
	'login with sony account': 'iniciar sesión con cuenta sony',
	'max ch week': 'máx cap semana',
	'merge category elements': 'fusionar categorías de elementos',
	'merge roles': 'fusionar roles',
	'milestone name': 'nombre del hito',
	'min x day': 'min x día',
	'minutes to produce daily location': 'minutos de producción diaria locación',
	'move scenes': 'mover escenas',
	'multiplier': 'multiplicador',
	'multiplier 4x': 'multiplicador 4x',
	'name portuguese': 'nombre portugués',
	'next step': 'siguiente paso',
	'nit': 'nit',
	'no drawings added to this scene': 'no hay dibujos agregados a esta escena',
	'oc#': 'oc#',
	'only establishing shoots': 'solo tomas de establecimiento',
	'only on day': 'solo de día',
	'only on exterior': 'solo en exterior',
	'only on interior': 'solo en interior',
	'only on location': 'solo en locación',
	'only on night': 'solo de noche',
	'only on studio': 'solo en estudio',
	'only script scenes': 'solo escenas de guión',
	'optional': 'opcional',
	'order': 'orden',
	'other video': 'otro video',
	'pages x chapter': 'páginas x capítulo',
	'paramedic on set': 'paramédico en set',
	'parameter/global': 'parámetro/global',
	'part': 'parte',
	'partially shoot': 'rodado parcial',
	'pashe': 'fase',
	'phone number': 'número de teléfono',
	'pitch': 'pitch',
	'please select a cover image to continue': 'por favor seleccione una imagen de portada para continuar',
	'post min': 'min post',
	'post-prod': 'post-prod',
	'post-production end': 'fin de post-producción',
	'pre-prod': 'pre-prod',
	'previous requests': 'solicitudes anteriores',
	'prod': 'prod',
	'prod pages': 'páginas prod',
	'production days': 'días de producción',
	'project statuses': 'estados de proyecto',
	'projected days': 'días proyectados',
	'projected shootings': 'planes proyectados',
	'protection type': 'tipo de protección',
	'prt': 'prot',
	'publish chapter': 'publicar capítulo',
	'quote number': 'número de cotización',
	'rate': 'tarifa',
	'ref minutes daily loc': 'ref minutos diarios loc',
	'ref minutes daily std': 'ref minutos diarios std',
	'registered vendor': 'proveedor registrado',
	'request new token': 'solicitar nuevo token',
	'requirements call': 'llamado de requerimientos',
	'retakes': 'repeticiones',
	'return': 'devolución',
	'revision expired': 'revisión expirada',
	'role name english': 'nombre del rol inglés',
	'role name español': 'nombre del rol español',
	'role name portuguese': 'nombre del rol portugués',
	'roles': 'roles',
	'save budget': 'guardar presupuesto',
	'save line': 'guardar línea',
	'scenes to produce daily location': 'escenas a producir diario locación',
	'scenes x chapter': 'escenas x capítulo',
	'schedule': 'programación',
	'season': 'temporada',
	'select': 'seleccionar',
	'select user': 'seleccionar usuario',
	'shooting date from': 'fecha de rodaje desde',
	'shooting date to': 'fecha de rodaje hasta',
	'shot at': 'rodado en',
	'shoting configuration types': 'tipos de configuración de rodaje',
	'show details': 'mostrar detalles',
	'sides': 'sides',
	'stripboard': 'stripboard',
	'sub-account': 'subcuenta',
	'suggestions': 'sugerencias',
	'supervisor': 'supervisor',
	'talent hours report': 'reporte de horas de talento',
	'text': 'texto',
	'there are no assets created': 'no hay activos creados',
	'there are no categories created': 'no hay categorías creadas',
	'there are no chapters created': 'no hay capítulos creados',
	'there are no drawings created on this shooting schedule': 'no hay dibujos creados en este plan de rodaje',
	'there are no events created': 'no hay eventos creados',
	'there are no locations created': 'no hay locaciones creadas',
	'there are no milestones created': 'no hay hitos creados',
	'there are no observations': 'no hay observaciones',
	'there are no parameters set up for this project': 'no hay parámetros configurados para este proyecto',
	'there are no projects created': 'no hay proyectos creados',
	'there are no releases': 'no hay relases',
	'there are no roles created': 'no hay roles creados',
	'there are no scenes created': 'no hay escenas creadas',
	'there are no sets created': 'no hay sets creados',
	'there are no shooting times created on this shooting schedule': 'no hay tiempos de rodaje creados en esta planificación',
	'there are no units created': 'no hay unidades creadas',
	'to access live view please provide your email address': 'para acceder a la vista en vivo por favor ingrese su correo electrónico',
	'to start': 'para comenzar',
	'transfer days': 'días de traslado',
	'un cancel': 'reactivar',
	'unassign': 'desasignar',
	'unassign user': 'desasignar usuario',
	'uncancel scene': 'reactivar escena',
	'use artistic name': 'usar nombre artístico',
	'use quantity': 'usar cantidad',
	'user email': 'correo del usuario',
	'vendor status': 'estado del proveedor',
	'video used': 'video utilizado',
	'view calendar': 'ver calendario',
	'view props': 'ver utilería',
	'working days': 'días laborales',
	'include in header': 'Incluir en cabecera',
	'sound notes': 'Notas de sonido',
}